/**
 * 形式上は正しくても受け付けない電話番号
 * @description ダミー入力として頻出する番号を個別に弾く
 */
export const PHONE_NUMBER_BLACKLIST: readonly string[] = [
  '09012345678',
]
